var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',[_c('Header')],1),_c('el-main',{class:{'main-content': _vm.bgColor }},[_c('div',{staticClass:"content-box"},[_c('router-view')],1),_c('div',{staticClass:"footer-box"},[_c('Footer')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }